enum TestBrandingType {
  UsabilityHub = "USABILITY_HUB",
  Unbranded = "UNBRANDED",
  WhiteLabel = "WHITE_LABEL",
}

export default TestBrandingType
